import { LanguageContext } from 'components/MainComponent/MainComponent'
import { scaleLinear } from 'd3-scale'
import { useContext } from 'react'
import styled from 'styled-components'

const lookupdata = require('./percentlookup.json')

const bgcolor = scaleLinear<string, string, never>()
  .domain([0, 150, 350, 450])
  .range(['#ffe462', '#e78d38', '#d3343f', '#9e272f'])

export const SquareDataDisplay = ({
  data,
  handleOverlayClose,
  text,
}: {
  data: { pop: number; pop_1km: number; RELI: number }
  handleOverlayClose: () => void
  text: string
}) => {
  const Locales = useContext(LanguageContext)
  let percent = lookupdata
    .filter(
      (d: { group: number; perc: number }) => d && d.group >= data.pop_1km
    )
    .sort(
      (
        a: { group: number; perc: number },
        b: { group: number; perc: number }
      ) => a.group - b.group
    )[0]

  let numberToDisplay =
    percent.perc < 50
      ? percent.perc.toFixed(0)
      : (100 - percent.perc).toFixed(0)
  if (numberToDisplay === '0') numberToDisplay = Locales.lessThanOne

  let percentDisplay =
    percent &&
    (percent.perc > 99 ? Locales.lessThanOne : 100 - percent.perc.toFixed(0))

  return (
    <SquareDataDisplayRoot>
      <CloseButton onClick={handleOverlayClose}>X</CloseButton>
      <Row>
        {percentDisplay && text === 'de' && (
          <EvaluationText>
            Im ausgewählten Hektar{' '}
            <TextSquare
              style={{
                backgroundColor: bgcolor(data.pop),
              }}
            />{' '}
            wohnen <b>{Math.round(data.pop)} Personen</b>. Rundherum, innerhalb
            eines Quadratkilometers <TextKmSquare />, sind es{' '}
            <b>{Math.round(data.pop_1km).toLocaleString('de-CH')}</b>,{' '}
            <b>in der Schweiz wohnen {percentDisplay}% noch dichter</b>.
          </EvaluationText>
        )}
        {percentDisplay && text === 'fr' && (
          <EvaluationText>
            <b>{Math.round(data.pop)} personnes</b> vivent dans l'hectare
            sélectionné ({' '}
            <TextSquare
              style={{
                backgroundColor: bgcolor(data.pop),
              }}
            />{' '}
            ). Autour de cet hectare, à
            l'intérieur d'un kilomètre carré ( <TextKmSquare /> ), il y en a {" "}
             <b>{Math.round(data.pop_1km).toLocaleString('de-CH')}</b>,{' '}
            en Suisse <b>{percentDisplay}% habitent encore plus densément</b>.
          </EvaluationText>
        )}
      </Row>
    </SquareDataDisplayRoot>
  )
}

const CloseButton = styled.button`
  border: 0;
  background-color: transparent;
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  font-weight: 700;
  font-size: 15px;
  color: var(--brandblue-main) !important;
  &:hover {
    cursor: pointer;
  }
`

const EvaluationText = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5em;
  width: 100%;
  max-width: 98%;
`

const TextSquare = styled.span`
  display: inline-block;
  width: 13px;
  height: 13px;
`
const TextKmSquare = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2.5px solid var(--brandblue-main);
`
const SquareDataDisplayRoot = styled.div`
  pointer-events: all;
  position: absolute;
  bottom: 45px;
  z-index: 100;
  width: 330px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  color: var(--brandblue-main);
  padding: 10px;
  font-family: var(--font-sans-serif);
  font-size: 22px;
  box-shadow: 0 0 10px 2px rgb(0 0 0 / 10%);
  border-radius: 4px;
`
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* height: 140px; */
`
